export default "__VITE_ASSET__BRjSNsxy__"